import { SET_SOOTHE_PASS_SUBSCRIPTIONS } from '../Actions';

export default function (state = {}, action) {
    switch (action.type) {
        case SET_SOOTHE_PASS_SUBSCRIPTIONS:
            return action.payload;
        default:
            return state;
    }
}
